__turbopack_context__.v({
  "container": "virtual-agent-module-scss-module__DLpAwG__container",
  "container-dark-icon": "virtual-agent-module-scss-module__DLpAwG__container-dark-icon",
  "container-disabled": "virtual-agent-module-scss-module__DLpAwG__container-disabled",
  "container-icon": "virtual-agent-module-scss-module__DLpAwG__container-icon",
  "container-icon-chat-white": "virtual-agent-module-scss-module__DLpAwG__container-icon-chat-white",
  "container-text": "virtual-agent-module-scss-module__DLpAwG__container-text",
  "container-text-hidden": "virtual-agent-module-scss-module__DLpAwG__container-text-hidden",
  "container-transparent-icon": "virtual-agent-module-scss-module__DLpAwG__container-transparent-icon",
  "icon-chat": "virtual-agent-module-scss-module__DLpAwG__icon-chat",
});
